module.exports = __webpack_public_path__ + "static/media/MovingApp_android_4_preview.53b8ae4c.jpg";